import UseContext from "hooks/useContext";


const useModal = () => {
    const { setModalShow, setModalType } = UseContext();

    const toggle = (v) => {
        if (v) setModalType(v);
        setModalShow((prev) => !prev);
    };

    const switchModal = (modalType) => {
        setModalType(modalType);
        setModalShow(true);
    };

    return {
        toggle,
        switchModal,
    };
};

export default useModal;